import React from 'react';
import ReportsView from './ReportsView';

export interface ReportsRouteProps {
  className?: string;
}

const ReportsRoute: React.FC<ReportsRouteProps> = ({ className = '' }) => {
  return <ReportsView className={className} />;
};

export default ReportsRoute;
